module.exports = __webpack_public_path__ + "assets/lawandorder-1.6960c530.svg";